import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement, queryAssignedElements } from 'lit/decorators.js';
import componentStyles from './outline-accordion-baseline.css.lit';
import { OutlineAccordionBaselinePanel } from './outline-accordion-baseline-panel/outline-accordion-baseline-panel';
/**
 * The OutlineAccordionBaseline component
 * @element outline-accordion-baseline
 */
@customElement('outline-accordion-baseline')
export class OutlineAccordionBaseline extends OutlineElement {
  slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Reference to <outline-accordion-panels> in panels slot.
   */
  @queryAssignedElements({ slot: 'panels' })
  panels: OutlineAccordionBaselinePanel[];

  render(): TemplateResult {
    return html`
      <section class="accordion">
        <div class="accordion--top-content">
          <div class="accordion--heading">
            ${this.slots.conditionalSlot('heading', false)}
          </div>
          <div class="accordion--eyebrow">
            ${this.slots.conditionalSlot('eyebrow', false)}
          </div>
        </div>
        <div class="accordion--panels" @keydown=${this.handleKeyboardNav}>
          <slot name="panels"></slot>
        </div>
      </section>
    `;
  }

  /**
   * @param event
   * @returns void
   * Adds up/down arrow keyboard navigation.
   * TODO: try to refactor to something simpler.
   */
  handleKeyboardNav(event: KeyboardEvent) {
    let index = 0;
    const panels = this.panels;
    const start = Array.prototype.indexOf.call(
      panels,
      event.target as HTMLElement
    );

    // bail on wrong key
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }
    if (event.key === 'ArrowDown') {
      if (panels?.length && start + 1 > panels?.length - 1) {
        index = 0;
      } else index = start + 1;
    }
    if (event.key === 'ArrowUp') {
      if (panels?.length && start - 1 < 0) {
        index = panels?.length - 1;
      } else index = start - 1;
    }
    const focusTarget = panels?.[index] as unknown as HTMLElement;
    focusTarget.shadowRoot?.querySelector('button')?.focus();
  }
}
